//Main
import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
import store from "./index.js"
vue.use(vuex);


//store
const soporte = new vapi({
    baseURL: `${process.env.VUE_APP_REST}/api`,
    state: {
        Asoportescuantitativo: [],
        Asoportescualitativo: [],
        AsoporteDesagregacion: [],
        Asoporte:[]
    }
}).get({
    action: "getsoportescuantitativos",   
    path: function (obj) {
        return `/soporte/cuantitativo/${obj.idindicador}`;
    }, 
    onSuccess: (state, payload ) => {
        state.Asoportescuantitativo = payload.data;
    },
}).get({
    action: "getsoportescualitativostipovalor",   
    path: function (obj) {
        return `/soporte/cualitativotipovalor/${obj.idindicador}`;
    }, 
    onSuccess: (state, payload ) => {
        state.AsoporteDesagregacion = payload.data;
    },
}).get({
    action: "getsoportesHitos",   
    path: function (obj) {
        return `/soporte/hitos/${obj.idhito}`;
    }, 
    onSuccess: (state, payload ) => {
        state.Asoporte = payload.data;
    }
}).get({
    action: "getsoportesHitosbyind",   
    path: function (obj) {
        return `/soporte/hitosbyindiccador/${obj.idindicador}`;
    }, 
    onSuccess: (state, payload ) => {
        state.Asoporte = payload.data;
    }
}).get({
    action: "get_soportesbyavancenacional",   
    path: function (obj) {
        return `/soporte/avancenacional/${obj.idavancenacional}`;
    }, 
    onSuccess: (state, payload ) => {
        state.Asoporte = payload.data;
    }
}).get({
    action: "Get_soporteavancenacional",   
    path: function (obj) {
        return `/soporte/soporteavancenacional/${obj.idnacional}`;
    }, 
    onSuccess: (state, payload ) => {
        state.Asoporte = payload.data;
    }
}).get({
    action: "downloadsoporte",   
    path: function (obj) {
        return `/soporte/download/${obj.idindicador}/${obj.idsoporte}`
    }, 
    onError: (state, error) => {   
        store.dispatch("mensaje/set_error", error);  
        console.log(error) ;
    },
    onSuccess: (state, payload ) => {
        state.Asoporte = payload.data;           
            let cad = state.Asoporte.archivocompleto;
            var binary_string = window.atob(cad);
            var len = binary_string.length;
            var bytes = new Uint8Array(len);
            for (var i = 0; i < len; i++) {
                bytes[i] = binary_string.charCodeAt(i);
            }     
            var fileURL = window.URL.createObjectURL(new Blob([bytes.buffer]));
            var fileLink = document.createElement('a');
            fileLink.href = fileURL;
            fileLink.setAttribute('download', state.Asoporte.nombrearchivo);
            document.body.appendChild(fileLink);
            fileLink.click();            
        }
}).get({
    action: "downloadsoporteversion",   
    path: function (obj) {
        return `/versionado/soporte/download/${obj.idtabla}/${obj.idindicador}/${obj.idsoporte}`
    }, 
    onError: (state, error) => {   
        store.dispatch("mensaje/set_error", error);  
        console.log(error) ;
    },
    onSuccess: (state, payload ) => {
        state.Asoporte = payload.data;           
            let cad = state.Asoporte.archivocompleto;
            var binary_string = window.atob(cad);
            var len = binary_string.length;
            var bytes = new Uint8Array(len);
            for (var i = 0; i < len; i++) {
                bytes[i] = binary_string.charCodeAt(i);
            }     
            var fileURL = window.URL.createObjectURL(new Blob([bytes.buffer]));
            var fileLink = document.createElement('a');
            fileLink.href = fileURL;
            fileLink.setAttribute('download', state.Asoporte.nombrearchivo);
            document.body.appendChild(fileLink);
            fileLink.click();            
        }
}).get({
    action: "get_soporte_download",   
    path: function (obj) {
        return `/soporte/download/${obj.idsoporte}`
    }, 
    onError: (state, error) => {   
        store.dispatch("mensaje/set_error", error);  
        console.log(error) ;
    }
    ,
    onSuccess: (state, payload ) => {
        state.Asoporte = payload.data;           
            let cad = state.Asoporte.archivocompleto;
            var binary_string = window.atob(cad);
            var len = binary_string.length;
            var bytes = new Uint8Array(len);
            for (var i = 0; i < len; i++) {
                bytes[i] = binary_string.charCodeAt(i);
            }     
            var fileURL = window.URL.createObjectURL(new Blob([bytes.buffer]));
            var fileLink = document.createElement('a');
            fileLink.href = fileURL;
            fileLink.setAttribute('download', state.Asoporte.nombrearchivo);
            document.body.appendChild(fileLink);
            fileLink.click();            
        }
}).get({
    action: "getsoportescualitativos",   
    path: function (obj) {
        return `/soporte/cualitativo/${obj.idindicador}`;
    }, 
    onSuccess: (state, payload ) => {
        state.Asoportescualitativo = payload.data;
    }
}).get({
    action: "getcambiarestadosoporte",   
    path: function (obj) {
        return `/soporte/cambiarestadosoporte/${obj.idsoporte}`;
    }, 
    onSuccess: (state, payload ) => {
    
    }
}).put({
    action: "Putsoporte", 
    onSuccess: (state, payload ) => {
        store.dispatch("mensaje/set_success", payload);
    },
    onError: (state, error) => {   
        store.dispatch("mensaje/set_error", error);   
    }
}).put({
    action: "putversionadodatosadicionales", 
    path: function (obj) {
        return `/versionado/putversionadodatosadicionales`;
    },
    onSuccess: (state, payload ) => {
        store.dispatch("mensaje/set_success", payload);
    },
    onError: (state, error) => {   
        store.dispatch("mensaje/set_error", error);   
    }
}).put({
    action: "putversionadodatosadicionalestablas", 
    path: function (obj) {
        return `/versionado/putversionadodatosadicionalestablas`;
    },
    onSuccess: (state, payload ) => {
        store.dispatch("mensaje/set_success", payload);
    },
    onError: (state, error) => {   
        store.dispatch("mensaje/set_error", error);   
    }
}).getStore();

soporte.getters = {
    gsoportescuantitativos: state => {
        return state.Asoportescuantitativo.filter(p=> p.finalizado === false);
    },
    gsoportescualitativos: state => {
        return state.Asoportescualitativo.filter(p=> p.finalizado === false);
    },
    gsoportescuantitativosaprobados: state => {
        return state.Asoportescuantitativo.filter(p=> p.finalizado === true);
    },
    gsoportescualitativosaprobados: state => {
        return state.Asoportescualitativo.filter(p=> p.finalizado === true);
    },
    gsoportehito: state => {
        return state.Asoporte.filter(p=> p.finalizado === false);
    },
    gsoportehitoaprobados: state => {
        return state.Asoporte.filter(p=> p.finalizado === true);
    },
    gsoportes: state => {
        return state.Asoporte.filter(p=> p.idsoporte!==-1);
    },
    gsoportesavancenal: state => {
        return state.Asoporte;
    },
    gsoporteDesagregacion: state => {
        return state.AsoporteDesagregacion;
    },
}

export default soporte;